import React from 'react';
import { LuStore } from 'react-icons/lu';
import formatBRL from '../../../shared/utils/formatBRL';
import './DeliveryChannelCard.css';

// Substitui "Taxa de conversão" do mockup original — o sistema não
// rastreia visitas ao site hoje. Mostra o split de vendas online x
// presencial no mesmo card, no mesmo estilo visual dos KpiCards (ícone +
// card com borda).
const DeliveryChannelCard = ({ delivery }) => {
  const online = delivery?.online ?? { count: 0, amount: 0 };
  const presencial = delivery?.presencial ?? { count: 0, amount: 0 };
  const totalOrders = online.count + presencial.count;
  const onlinePct = totalOrders > 0 ? (online.count / totalOrders) * 100 : 0;

  return (
    <div className="delivery-channel-card">
      <div className="delivery-channel-card__icon">
        <LuStore size={22} />
      </div>
      <div className="delivery-channel-card__body">
        <span className="delivery-channel-card__label">Vendas online × presencial</span>
        <div className="delivery-channel-card__split">
          <span>Online: <strong>{online.count}</strong> — {formatBRL(online.amount)}</span>
          <span>Presencial: <strong>{presencial.count}</strong> — {formatBRL(presencial.amount)}</span>
        </div>
        <div className="delivery-channel-card__bar">
          <div className="delivery-channel-card__bar-online" style={{ width: `${onlinePct}%` }} />
        </div>
      </div>
    </div>
  );
};

export default DeliveryChannelCard;
